export default __webpack_public_path__ + "static/media/bg-square-shape-left-min.75d13b42.png";